import request from '@/utils/request'
const BASE_URL = '/Address'

export default {
  list(data) {
    return request({
      url: BASE_URL + '/list',
      method: 'post',
      data
    })
  },
  GetDistrictList(params) {
    return request({
      url: BASE_URL + '/GetDistrictList',
      method: 'get',
      params
    })
  },
}